export default "__VITE_ASSET__DGhkbNb6__"